import { useState, useEffect } from 'react'
import { Group } from '@mantine/core'
import { Cropper } from 'react-cropper'
import { AppButton, AppModal } from '../../app/common/ui'
import 'cropperjs/dist/cropper.css'

interface Props {
  file: File | null;
  open: boolean;
  onClose: () => void;
  onCrop: (blob: Blob) => Promise<void>;
  loading: boolean;
}

export default function PhotoUploadCropModal ({ file, open, onClose, onCrop, loading }: Props) {
  const [cropper, setCropper] = useState<Cropper>()
  const [preview, setPreview] = useState<string>('')

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file)
      setPreview(url)
      return () => URL.revokeObjectURL(url)
    } else {
      setPreview('')
    }
  }, [file])

  const handleCrop = async () => {
    if (!cropper) return
    cropper.getCroppedCanvas().toBlob(async (blob) => {
      if (blob) await onCrop(blob)
    }, 'image/jpeg', 0.85)
  }

  return (
    <AppModal opened={open} onClose={onClose} title="Crop photo" size="lg">
      {preview && (
        <>
          <Cropper
            src={preview}
            style={{ height: 320, width: '100%' }}
            initialAspectRatio={1}
            aspectRatio={1}
            guides={false}
            viewMode={1}
            onInitialized={(c) => setCropper(c)}
          />
          <Group position="right" mt="md">
            <AppButton variant="default" onClick={onClose} disabled={loading}>
              Cancel
            </AppButton>
            <AppButton onClick={handleCrop} loading={loading}>
              Upload
            </AppButton>
          </Group>
        </>
      )}
    </AppModal>
  )
}
